import React from 'react';
import PhoneInput from 'react-phone-input-2';

import useStyles from './styles.js';

const toDigits = value => (value || '').replace(/\D/g, '');

const PhoneFlagInput = ({ onChange, inputRef, setFieldValue, ...field }) => {
  const classes = useStyles();

  const countryDataFormatKey = `${field.name}_countryDataFormat_`;
  const countryDataDialCodeKey = `${field.name}_countryDataDialCode_`;

  const formikValue = toDigits(field.value);

  return (
    <PhoneInput
      {...field}
      value={formikValue}
      specialLabel=""
      placeholder=""
      country="us"
      onMount={(value, countryData) => {
        sessionStorage.setItem(countryDataFormatKey, countryData.format);
        sessionStorage.setItem(countryDataDialCodeKey, countryData.dialCode);
      }}
      onChange={async (value, countryData, e) => {
        sessionStorage.setItem(countryDataFormatKey, countryData.format);
        sessionStorage.setItem(countryDataDialCodeKey, countryData.dialCode);

        await setFieldValue(field.name, value || '');
          
        e.persist();
        onChange(e);
      }}
      inputProps={{ ref: inputRef, name: field.name, autoComplete: 'tel' }}
      containerClass={classes.container}
      inputClass={classes.input}
    />
  );
};

export default PhoneFlagInput;
